import React, { Fragment } from 'react';
import { MetricsElement } from "react-metrics";

import '../css/xsell-modal-printer.less';

// check with Victor
// onClick={() => this.setState({busy: true})}

class Prechecked extends React.PureComponent {
	state = {
		buttonBusy: false,
		instantInkClicked: false,
	}

	handleContinueClick() {
		const { proceed, version, ctaMetrics } = this.props;
		this.setState({
			buttonBusy: true
		}, () => {
			proceed(version, ctaMetrics)
		})
	}

	handleInstantInkClick() {
		this.setState({ instantInkClicked: !this.state.instantInkClicked })
	}

	render() {
		const { name, xSellProductList, setHTML, crtUrl, version } = this.props;
		const { instantInkClicked } = this.state;
		const isOriginal = version === '' || version === 'original';
		return (
			<Fragment>
				<div className='modal-header'>
					<h3>{name} has been added to cart.</h3>
				</div>
				<div className='modal-content'>
					<div className='products-section'>
						{isOriginal && <h3 className='content-header'>Original HP ink</h3>}
						{!isOriginal && <h3>For your convenience, we are adding our most popular back-up cartridges to your printer order</h3>}
						<div className='xsell-product-list'>
							{ xSellProductList }
						</div>
						<p>Get up to 2x the pages with Original HP XL inks vs. standard cartridges.</p>
					</div>
					{
						(version === 'instantInk') && 
						<div className="instant-ink-section">
							<div className="header-img-holder"></div>
							<h3 className='content-header'>Save up to 50% on ink</h3>
							<p>Instant Ink is HP’s ink delivery service.</p>
							<p>Plans start at $2.99/month.</p>
							<p>Black and color ink, and shipping are included in the service.</p>
							<MetricsElement>
								<div 
									data-metrics-event-name="linkClick"
									data-metrics-event="e_linkClick"
									data-metrics-link-id={'printer-xsell:checkbox:var1'}
									className={'tell-me-more checkbox'} 
									onClick={() => this.handleInstantInkClick()}
								>
									<span className={`add-checkbox${instantInkClicked ? ' checkbox-selected' : ''}`}></span>
									<span>Tell me more via email</span>
								</div>
							</MetricsElement>
						</div>
					}
				</div>
				<div className='modal-footer'>
					{isOriginal && <h3>For your convenience, we are adding our most popular back-up cartridges to your printer order</h3>}
					<div className='btn-container'>
						<a href={ setHTML(crtUrl) } className='tabs-link'>
							<div className={`btn btn-primary purchase-btn custom-btn${isOriginal ? '' : ' white-background'}`}>{`No thanks, please remove${isOriginal ? '' : ' cartridges'}`}</div>
						</a>
						<a href='javascript:void(0)' className='tabs-link'>
							<div className={`btn btn-primary purchase-btn custom-btn${isOriginal ? ' red' : ''}${this.state.buttonBusy ? ' busy' : ''}`} 
								onClick={ () => this.handleContinueClick() }>
								{`${isOriginal ? '' : 'Thanks, '}Continue to cart`}
							</div>
						</a>
					</div>
				</div>
			</Fragment>
		)
	}
}

export default Prechecked;